module.exports = __webpack_public_path__ + "img/people-fill.51e617b8.svg";